import { Link } from "react-router-dom";
import { Seo } from "../components/layout/Seo";

export default function NotFound() {
  return (
    <section className="grid min-h-[80vh] place-items-center bg-[#0C0A09] px-5 pt-24 text-center text-stone-100">
      <Seo title="Page not found | TechCare Technologies" description="The page you were looking for could not be found." />
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-orange-400">404 · Signal lost</p>
        <h1 className="mt-6 font-display text-5xl sm:text-7xl">Nothing here yet.</h1>
        <Link to="/" className="tc-btn-primary mt-10 inline-flex h-12 items-center rounded-full px-7 text-sm font-semibold" data-testid="notfound-home-link">Back to home</Link>
      </div>
    </section>
  );
}
